
import { useDataQuery } from '@dhis2/app-runtime';

export const useUserOrgUnits = () => {
  const { loading, error, data } = useDataQuery({
    me: {
      resource: 'me',
      params: {
        fields: 'organisationUnits[id,displayName,path]'
      }
    }
  });

  return {
    loading,
    error,
    userOrgUnits: data?.me?.organisationUnits || []
  };
};